<div style="background-color: #ffffff" class="paddedContent">
  <app-edit-catalog-item
    [itemId]="itemId"
    [catalogId]="catalogId"
    (saved)="handleSaved()"
    (cancelled)="handleCancelled()"
  ></app-edit-catalog-item>
</div>
